// components/StepIndicator.js
import React from 'react';

const StepIndicator = ({ currentStep }) => {
    const steps = [
        { number: 1, label: 'Basic Info' },
        { number: 2, label: 'Reward' },
        { number: 3, label: 'Finalize' }
    ];

    return (
        <div className="stepmain">
            {steps.map((step, index) => (
                <div
                    key={step.number}
                    className={`stepinner
            ${currentStep === step.number ? "active-step" : ""}
            ${currentStep > step.number ? "completed-step" : ""}`}
                >
                    <span
                        className={`stepline ${currentStep > step.number
                                ? "completed"
                                : currentStep === step.number
                                    ? "active"
                                    : ""
                            }`}
                    >
                        {currentStep > step.number ? (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                            >
                                <path
                                    d="M10 3L4.5 8.5L2 6"
                                    stroke="white"
                                    strokeWidth="1.25"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        ) : (
                            step.number
                        )}
                    </span>
                    <p className={`steppara ${currentStep >= step.number ? "whitepara" : "inactivepara"}`}>
                        {step.label}
                        {index < steps.length - 1 && (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                            >
                                <path
                                    d="M4.5 9L7.5 6L4.5 3"
                                    stroke="white"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        )}
                    </p>
                </div>
            ))}
        </div>
    );
};

export default StepIndicator;